import { memo } from 'react'

import { MarketBot } from './style'
import Header from './Header'
import Content from './Content'
import Footer from './Footer'

function App() {

  return (
    <MarketBot>
      <Header />
      <Content />
    </MarketBot>
  )
}

export default memo(App)